import { FC } from 'react'
import styled from 'styled-components'
import { validFor } from '@/theme/validFor'
import {
  LandingPageSection,
  LandingPageSectionPosition
} from '@/network/graphql.g'
import { H1 } from '@/components/atoms/typography'
import Link from '@/components/atoms/link'
import { Box, Flex } from '@/components/atoms/Grid'
import { BigAccentButton } from '@/components/atoms/button'

type SummerCategoriesProps = {
  position: string
  blackFridaySections: LandingPageSection[]
}

const SummerCategories: FC<SummerCategoriesProps> = ({
  position,
  blackFridaySections
}) => {
  const blackFridayCategory = blackFridaySections.find(
    (element) => element.position === position
  )
  const blackFridaySortCategories = [...blackFridayCategory.categories].sort(
    (a, b) => a.sort - b.sort
  )

  const { name } = blackFridayCategory

  return (
    <Wrapper position={position}>
      <StyledFlex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <StyledH1>{name}</StyledH1>
        {blackFridaySortCategories.map((item) => (
          <Link href={item.link} key={item.sort}>
            <StyledSummerButton title={item.name} />
          </Link>
        ))}
      </StyledFlex>
    </Wrapper>
  )
}

export default SummerCategories

const Wrapper = styled(Box)`
  height: 100%;
  background-image: ${(props) =>
    (props.position === LandingPageSectionPosition.TopLeft &&
      'url(https://i.factcool.com/summer/landing-page-summer_02.jpg)') ||
    (props.position === LandingPageSectionPosition.TopRight &&
      'url(https://i.factcool.com/summer/landing-page-summer_03.jpg)')};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  ${validFor.mobile`
    width: 100%;
    background-image: ${(props) =>
      props.position === LandingPageSectionPosition.TopRight && 'none'}
  `}
  ${validFor.tablet`
    width:50%
  `}
  ${validFor.desktop`
    width: 50%
  `} 
  text-align: center;
  &:hover {
    ${({ isClickable }) => isClickable && 'cursor: pointer'}
  }
`
const StyledSummerButton = styled(BigAccentButton)`
  background-color: ${(props) => props.theme.colors.summerBackgroundButton};
  color: ${(props) => props.theme.colors.onBackground};
  margin-bottom: 15px;
  width: 275px;
  text-transform: none;
  p {
    letter-spacing: 2px;
  }
  ${validFor.mobile`
    width: 225px
  `}
  ${validFor.tablet`
    width: 225px
  `}
`
const StyledFlex = styled(Flex)`
  height: 90%;
`
const StyledH1 = styled(H1)`
  font-size: 40px;
  letter-spacing: 2px;
  color: ${(props) => props.theme.colors.onBackground};
  ${validFor.mobile`
    font-size: 32px;
    margin-top: 40px;
  `}
  ${validFor.tablet`
    font-size: 36px;
  `}
`
